<template>
  <div>
    <!--TopView></TopView-->
    <router-view></router-view>
  </div>

</template>

<script setup lang="ts">
 // import TopView  from '@/views/TopView.vue';

</script>